/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApiError,
  CreateOnboardingSignedUrlBody,
  CreateOnboardingThirdPartyBody,
  GetOnboardingInformationResponse,
  GetOnboardingThirdPartiesResponse,
  GetOnboardingThirdPartiesSort,
  OnboardingSignedUrl,
  OnboardingThirdParty,
  SortOrder,
} from '../models/index';
import {
    ApiErrorFromJSON,
    ApiErrorToJSON,
    CreateOnboardingSignedUrlBodyFromJSON,
    CreateOnboardingSignedUrlBodyToJSON,
    CreateOnboardingThirdPartyBodyFromJSON,
    CreateOnboardingThirdPartyBodyToJSON,
    GetOnboardingInformationResponseFromJSON,
    GetOnboardingInformationResponseToJSON,
    GetOnboardingThirdPartiesResponseFromJSON,
    GetOnboardingThirdPartiesResponseToJSON,
    GetOnboardingThirdPartiesSortFromJSON,
    GetOnboardingThirdPartiesSortToJSON,
    OnboardingSignedUrlFromJSON,
    OnboardingSignedUrlToJSON,
    OnboardingThirdPartyFromJSON,
    OnboardingThirdPartyToJSON,
    SortOrderFromJSON,
    SortOrderToJSON,
} from '../models/index';

export interface CreateOnboardingSignedUrlRequest {
    createOnboardingSignedUrlBody?: CreateOnboardingSignedUrlBody;
}

export interface CreateOnboardingThirdPartyRequest {
    createOnboardingThirdPartyBody?: CreateOnboardingThirdPartyBody;
}

export interface DeleteOnboardingThirdPartyIdRequest {
    id: string;
}

export interface GetOnboardingSignedUrlInformationSignedUrlKeyRequest {
    signedUrlKey: string;
}

export interface GetOnboardingThirdPartiesRequest {
    search?: string;
    sort?: GetOnboardingThirdPartiesSort;
    order?: SortOrder;
    limit?: number;
    offset?: number;
    numberOfAvailableOffsets?: number;
}

export interface UpdateOnboardingSignedUrlMergeUserSignedUrlKeyRequest {
    signedUrlKey: string;
    body?: object;
}

/**
 * OnboardingApi - interface
 * 
 * @export
 * @interface OnboardingApiInterface
 */
export interface OnboardingApiInterface {
    /**
     * Creates a new signed-url for onboarding a user from one platform to DevourGo.
     * @param {CreateOnboardingSignedUrlBody} [createOnboardingSignedUrlBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingApiInterface
     */
    createOnboardingSignedUrlRaw(requestParameters: CreateOnboardingSignedUrlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OnboardingSignedUrl>>;

    /**
     * Creates a new signed-url for onboarding a user from one platform to DevourGo.
     */
    createOnboardingSignedUrl(requestParameters: CreateOnboardingSignedUrlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OnboardingSignedUrl>;

    /**
     * Creates a new Onboarding Third Party and generates the public and secret keys. This will return the secret key, which needs to be saved, as it is the only time it will be shown.
     * @param {CreateOnboardingThirdPartyBody} [createOnboardingThirdPartyBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingApiInterface
     */
    createOnboardingThirdPartyRaw(requestParameters: CreateOnboardingThirdPartyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OnboardingThirdParty>>;

    /**
     * Creates a new Onboarding Third Party and generates the public and secret keys. This will return the secret key, which needs to be saved, as it is the only time it will be shown.
     */
    createOnboardingThirdParty(requestParameters: CreateOnboardingThirdPartyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OnboardingThirdParty>;

    /**
     * Deletes an Onboarding Third Party by ID.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingApiInterface
     */
    deleteOnboardingThirdPartyIdRaw(requestParameters: DeleteOnboardingThirdPartyIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Deletes an Onboarding Third Party by ID.
     */
    deleteOnboardingThirdPartyId(requestParameters: DeleteOnboardingThirdPartyIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * gets the information associated with a signedUrlKey.
     * @param {string} signedUrlKey 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingApiInterface
     */
    getOnboardingSignedUrlInformationSignedUrlKeyRaw(requestParameters: GetOnboardingSignedUrlInformationSignedUrlKeyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetOnboardingInformationResponse>>;

    /**
     * gets the information associated with a signedUrlKey.
     */
    getOnboardingSignedUrlInformationSignedUrlKey(requestParameters: GetOnboardingSignedUrlInformationSignedUrlKeyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetOnboardingInformationResponse>;

    /**
     * 
     * @param {string} [search] will search over name, description, public key, and the secret key. You can type the secret key in here to confirm who it was given to.
     * @param {GetOnboardingThirdPartiesSort} [sort] 
     * @param {SortOrder} [order] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {number} [numberOfAvailableOffsets] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingApiInterface
     */
    getOnboardingThirdPartiesRaw(requestParameters: GetOnboardingThirdPartiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetOnboardingThirdPartiesResponse>>;

    /**
     */
    getOnboardingThirdParties(requestParameters: GetOnboardingThirdPartiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetOnboardingThirdPartiesResponse>;

    /**
     * gets the information associated with a signedUrlKey.
     * @param {string} signedUrlKey 
     * @param {object} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingApiInterface
     */
    updateOnboardingSignedUrlMergeUserSignedUrlKeyRaw(requestParameters: UpdateOnboardingSignedUrlMergeUserSignedUrlKeyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * gets the information associated with a signedUrlKey.
     */
    updateOnboardingSignedUrlMergeUserSignedUrlKey(requestParameters: UpdateOnboardingSignedUrlMergeUserSignedUrlKeyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

}

/**
 * 
 */
export class OnboardingApi extends runtime.BaseAPI implements OnboardingApiInterface {

    /**
     * Creates a new signed-url for onboarding a user from one platform to DevourGo.
     */
    async createOnboardingSignedUrlRaw(requestParameters: CreateOnboardingSignedUrlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OnboardingSignedUrl>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/onboarding/signed-url`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateOnboardingSignedUrlBodyToJSON(requestParameters['createOnboardingSignedUrlBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OnboardingSignedUrlFromJSON(jsonValue));
    }

    /**
     * Creates a new signed-url for onboarding a user from one platform to DevourGo.
     */
    async createOnboardingSignedUrl(requestParameters: CreateOnboardingSignedUrlRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OnboardingSignedUrl> {
        const response = await this.createOnboardingSignedUrlRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new Onboarding Third Party and generates the public and secret keys. This will return the secret key, which needs to be saved, as it is the only time it will be shown.
     */
    async createOnboardingThirdPartyRaw(requestParameters: CreateOnboardingThirdPartyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OnboardingThirdParty>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/onboarding/third-party`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateOnboardingThirdPartyBodyToJSON(requestParameters['createOnboardingThirdPartyBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OnboardingThirdPartyFromJSON(jsonValue));
    }

    /**
     * Creates a new Onboarding Third Party and generates the public and secret keys. This will return the secret key, which needs to be saved, as it is the only time it will be shown.
     */
    async createOnboardingThirdParty(requestParameters: CreateOnboardingThirdPartyRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OnboardingThirdParty> {
        const response = await this.createOnboardingThirdPartyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Deletes an Onboarding Third Party by ID.
     */
    async deleteOnboardingThirdPartyIdRaw(requestParameters: DeleteOnboardingThirdPartyIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteOnboardingThirdPartyId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/onboarding/third-party/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes an Onboarding Third Party by ID.
     */
    async deleteOnboardingThirdPartyId(requestParameters: DeleteOnboardingThirdPartyIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteOnboardingThirdPartyIdRaw(requestParameters, initOverrides);
    }

    /**
     * gets the information associated with a signedUrlKey.
     */
    async getOnboardingSignedUrlInformationSignedUrlKeyRaw(requestParameters: GetOnboardingSignedUrlInformationSignedUrlKeyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetOnboardingInformationResponse>> {
        if (requestParameters['signedUrlKey'] == null) {
            throw new runtime.RequiredError(
                'signedUrlKey',
                'Required parameter "signedUrlKey" was null or undefined when calling getOnboardingSignedUrlInformationSignedUrlKey().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/onboarding/signed-url/information/{signedUrlKey}`;
        urlPath = urlPath.replace(`{${"signedUrlKey"}}`, encodeURIComponent(String(requestParameters['signedUrlKey'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetOnboardingInformationResponseFromJSON(jsonValue));
    }

    /**
     * gets the information associated with a signedUrlKey.
     */
    async getOnboardingSignedUrlInformationSignedUrlKey(requestParameters: GetOnboardingSignedUrlInformationSignedUrlKeyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetOnboardingInformationResponse> {
        const response = await this.getOnboardingSignedUrlInformationSignedUrlKeyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getOnboardingThirdPartiesRaw(requestParameters: GetOnboardingThirdPartiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetOnboardingThirdPartiesResponse>> {
        const queryParameters: any = {};

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        if (requestParameters['order'] != null) {
            queryParameters['order'] = requestParameters['order'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['numberOfAvailableOffsets'] != null) {
            queryParameters['numberOfAvailableOffsets'] = requestParameters['numberOfAvailableOffsets'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/onboarding/third-parties`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetOnboardingThirdPartiesResponseFromJSON(jsonValue));
    }

    /**
     */
    async getOnboardingThirdParties(requestParameters: GetOnboardingThirdPartiesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetOnboardingThirdPartiesResponse> {
        const response = await this.getOnboardingThirdPartiesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * gets the information associated with a signedUrlKey.
     */
    async updateOnboardingSignedUrlMergeUserSignedUrlKeyRaw(requestParameters: UpdateOnboardingSignedUrlMergeUserSignedUrlKeyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['signedUrlKey'] == null) {
            throw new runtime.RequiredError(
                'signedUrlKey',
                'Required parameter "signedUrlKey" was null or undefined when calling updateOnboardingSignedUrlMergeUserSignedUrlKey().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/onboarding/signed-url/merge-user/{signedUrlKey}`;
        urlPath = urlPath.replace(`{${"signedUrlKey"}}`, encodeURIComponent(String(requestParameters['signedUrlKey'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * gets the information associated with a signedUrlKey.
     */
    async updateOnboardingSignedUrlMergeUserSignedUrlKey(requestParameters: UpdateOnboardingSignedUrlMergeUserSignedUrlKeyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateOnboardingSignedUrlMergeUserSignedUrlKeyRaw(requestParameters, initOverrides);
    }

}
